import { ZoomBlurFilter } from "@pixi/filter-zoom-blur";
import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "common/screen";
export class ZoomEffector {
    constructor(pixiContext, container) {
        this.speed = 1;
        this.pixiContext = pixiContext;
        this.container = container;
    }
    setSpeed(speed) {
        if (this.speed === speed) {
            return;
        }
        if (speed < 3) {
            if (this.speed === 3) {
                this.zoomEffectAnimation(0.1, 0);
            }
            else {
                this.container.filters = [];
            }
        }
        else if (speed === 3) {
            if (this.speed === 2) {
                this.zoomEffectAnimation(0, 0.1);
            }
            else {
                const zoomFilter = new ZoomBlurFilter({
                    center: [MAXIMUM_WIDTH / 2, MAXIMUM_HEIGHT / 2],
                    strength: 0.1,
                });
                this.container.filters = [zoomFilter];
            }
        }
        else if (speed === 4) {
            const zoomFilter = new ZoomBlurFilter({
                center: [MAXIMUM_WIDTH / 2, MAXIMUM_HEIGHT / 2],
                strength: 0.2,
            });
            this.container.filters = [zoomFilter];
        }
        this.speed = speed;
    }
    async zoomEffectAnimation(from, to) {
        for (let i = 0; i < 10; i += 1) {
            const zoomFilter = new ZoomBlurFilter({
                center: [MAXIMUM_WIDTH / 2, MAXIMUM_HEIGHT / 2],
                strength: from + (to - from) * (i / 10),
            });
            this.container.filters = [zoomFilter];
            await this.pixiContext.delay(100);
        }
    }
}
//# sourceMappingURL=zoomEffect.js.map